/* שירות הפנייה מהאתר — עוטף את קריאת ה-API ומחזיר טיפוס מהחוזה המשותף. */
import type { ContactRequest, ContactResponse } from '@shared/contact.types';
import { request } from './api-client';

export function sendContactRequest(payload: ContactRequest): Promise<ContactResponse> {
  return request<ContactResponse>('/api/contact', {
    method: 'POST',
    body: payload,
  });
}
